const firebaseConfig = {
  apiKey: "AIzaSyCOVS1Md7VMRSNKlrnicL7eTOO9H6oebgs",
  authDomain: "coinhub-b752a.firebaseapp.com",
  projectId: "coinhub-b752a",
  storageBucket: "coinhub-b752a.appspot.com",
  messagingSenderId: "535265691881",
  appId: "1:535265691881:web:af5f5dfa9c7fd7d79d0878",
};

export default firebaseConfig;
